import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Profile } from './components/Profile';
import { Opportunity } from './components/Opportunity';
import { Benefits } from './components/Benefits';
import { Credibility } from './components/Credibility';
import { Partners } from './components/Partners';
import { Impact } from './components/Impact';
import { Conversemos } from './components/Conversemos';
import { LeadForm } from './components/LeadForm';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-ivory font-sans" data-id="element-0" data-mp="2wiyv4mpflj91">
      <Nav data-id="element-1" data-mp="2wi5pxq64f1t0" />
      <main data-id="element-2" data-mp="28u5xmlt5v3cb">
        <Hero data-id="element-3" data-mp="28tw9l3rof699" />
        <Profile data-id="element-4" data-mp="28te2fc3h77mk" />
        <Opportunity data-id="element-5" data-mp="28suvsrja05nu" />
        <Benefits data-id="element-6" data-mp="28sbe9bxjfjac" />
        <Credibility data-id="element-7" data-mp="23vkwmk634fmt" />
        <Partners data-id="element-8" data-mp="23w4e5zrtp20b" />
        <Impact data-id="element-9" data-mp="23ujlygszdv5m" />
        <Conversemos data-id="element-10" data-mp="23v2sz2h3ez4v" />
        <LeadForm data-id="element-11" data-mp="23ti5txx3yih1" />
        <Faq data-id="element-12" data-mp="3ik7jmqgv0tve" />
      </main>
      <Footer data-id="element-13" data-mp="3iiwg8rrbto4t" />
    </div>;
}